/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck

import React from 'react';
import Card from 'react-bootstrap/Card';
import { Row, Col, Table, Button } from 'react-bootstrap';
import {
  ListItemsComp,
  IOptionsProps,
} from '../../../../widgets/list-items-widget-react';
import { BeneficiaryComp } from './components/Beneficiary';
import * as S from './styles';

export interface IPreviewCompProps {
  label?: string;
  subTitle?: string;
  headerTitle?: string;
  payoutTitle?: string;
  description?: string;
  policySelected?: IOptionsProps[];
  policyHolderTitle?: string;
  beneficiaryTitle?: string;
  beneficiary?: {
    firstName?: string;
    lastName?: string;
    streetAddress?: string;
    email?: string;
    telephone?: string;
    city?: string;
    country?: string;
  };
  policyHolder: {
    firstName?: string;
    lastName?: string;
    streetAddress?: string;
    email?: string;
    telephone?: string;
    city?: string;
    country?: string;
  };
  headers?: string[];
  paymentOption?: {
    title?: string;
    subtitle?: string;
    payonline?: string;
    subheader_1?: string;
    creditunion?: string;
    subheader_2?: string;
  };

  onPolicyPreviewSubmit?(): void;
  submitButtonTitle?: string;
  payouts?: any[];
}
export const PolicyPreview = (props: IPreviewCompProps) => {
  const {
    label,
    description,
    beneficiary,
    submitButtonTitle,
    policyHolderTitle,
    beneficiaryTitle,
    policyHolder,
    paymentOption,
    payouts,
    policySelected,
    payoutTitle,
    headerTitle,
    headers,
    onPolicyPreviewSubmit,
  } = props;

  const _getListItems = (item: any) => {
    let tempList: any = [];
    Array.isArray(item?.triggeringParams) &&
      item?.triggeringParams?.map((key: any) => {
        tempList.push({
          percent: `${key?.coveragePct}%`,
          title: Object.values(key?.params[0]),
          value: key?.coverage?.formatted,
        });
      });
    return tempList;
  };

  const _getPolicy = (policy: any) => {
    let _temp = [
      {
        title: 'Policy',
        value: policy?.label,
      },
      {
        title: 'Premium',
        value: policy?.premium?.formatted,
      },
    ];
    return _temp;
  };

  return (
    <>
      {/* <Container> */}

      {headerTitle && (
        <S.mainHeading className="mb-2 mt-4">{headerTitle}</S.mainHeading>
      )}
      <Row className="mb-4">
        <Col xs={12}>
          <ListItemsComp listItems={_getPolicy(policySelected)} />
        </Col>
        <Col xs={12} className="mt-4">
          {beneficiary && (
            <BeneficiaryComp
              title={policyHolderTitle}
              policyHolder={policyHolder}
            />
          )}
        </Col>
        <Col xs={12} className="mt-4">
          {beneficiary && (
            <BeneficiaryComp
              title={beneficiaryTitle}
              policyHolder={beneficiary}
            />
          )}
        </Col>
        <Col xs={12} className="mt-4">
          {payoutTitle && (
            <S.mainHeading className="mb-2">{payoutTitle}</S.mainHeading>
          )}
          <ListItemsComp
            listItems={_getListItems(policySelected)}
            headers={headers}
          />
        </Col>
      </Row>
      <div style={{ marginTop: '5%' }}>
        <Button
          className="text-dark me-3"
          variant="secondary"
          style={{ float: 'right' }}
          size="lg"
          onClick={onPolicyPreviewSubmit}
        >
          {submitButtonTitle}
        </Button>
      </div>
    </>
  );
};
PolicyPreview.defaultProps = {
  payoutTitle: 'Payout Scenario',
  headerTitle: 'Policy Details',
  subTitle: 'Policy Option T',
  description: 'Policy Coverage T is the most comprehensive CoveragePolicy ',
  payouts: [
    {
      percent: '10%',
      title: ['Tropical Storm', 'Box 1'],
      value: '$100',
    },
    {
      percent: '25%',
      title: ['Category 1', 'Box 1'],
      value: '$250',
    },
    {
      percent: '25%',
      title: ['Category 2', 'Box 1, 2'],
      value: '$250',
    },
    {
      percent: '50%',
      title: ['Category 3', 'Box 1, 2'],
      value: '$500',
    },
    {
      percent: '50%',
      title: ['Category 4', 'Box 1, 2, 3'],
      value: '$500',
    },
    {
      percent: '100%',
      title: ['Category 5', 'Box 1, 2, 3'],
      value: '$1000',
    },
  ],
  policySelected: [
    {
      title: 'Policy',
      value: 'Policy Option T',
    },
    {
      title: 'Premium',
      value: '$250',
    },
  ],
  submitButtonTitle: 'Next',
  policyHolderTitle: 'Policy Holder',
  beneficiaryTitle: 'Nominee details',
};
